<template>
    <div>

        <div style="position: fixed; top: 0; left: 0; right: 0; z-index: 999" class="payment">
            <van-nav-bar :title="pageTitle" @click-left="goBack" left-arrow>
            </van-nav-bar>
        </div>

        <div style="padding-top: 46px">

            <div class="info-title" v-if="isConfirmType">确认件证明文件</div>

            <div class="form-info-panel" style="padding: 0.4rem; text-align: left" v-if="isConfirmType">
                <div v-for="(item, index) in confirm_proofs" :key="item" style="padding-bottom: 24px">
                    <div style="position: relative">
                        <div style="font-size: 14px; font-weight: bold">{{ getFileNameFromUrl(item) }}</div>
                        <div style="font-size: 12px; margin-top: 6px">上传类型：{{ isPdfUrl(item) ? 'pdf' : (isDocxUrl(item)?'docx':'image') }}</div>
                        <div style="font-size: 12px; margin-top: 6px">
                            <FileSizeCheck :url="item" :limit="8" />
                        </div>

                        <div style="position: absolute; right: 0; font-size: 22px !important; top: 50%; transform: translateY(-50%); color: #1889f9 !important; display: flex; gap: 8px;">
                            <!-- 如果是图片类型，添加查看按钮 -->
                            <van-icon
                                v-if="!isPdfUrl(item) && !isDocxUrl(item)"
                                name="eye-o"
                                style="display: inline-block; vertical-align: middle; font-size: 22px !important; color: #1889f9 !important; cursor: pointer;"
                                @click.stop="previewConfirmProof(item)"
                            />
                            <van-icon name="delete" style="display: inline-block; vertical-align: middle; font-size: 22px !important; color: #1889f9 !important; cursor: pointer;" @click.stop="deleteConfirmProof(index)" />
                        </div>
                    </div>
                </div>

                <a style="display: inline-block; width: 100%; border-radius: 0.125rem; line-height: 0.7rem; font-family: PingFangSC-Regular; font-size: 0.3rem; color: #1889f9; border: 1px solid #9f9f9f; text-align: center; position: relative;" href="javascript:void(0);" v-bind:class="{ inEdit: !nextStepValid }">
                    <van-icon name="add-o" style="display: inline-block; margin-right: 6px; vertical-align: middle;" />
                    <span style="display: inline-block; vertical-align: middle">上传确认件</span>

                    <input type="file" style="position: absolute; z-index: 999; top: 0; right: 0; bottom: 0; left: 0; opacity: 0;" accept="application/pdf,.docx,image/*" @change="getConfirmProofFile" ref="uploadConfirm" />
                </a>
            </div>


            <div class="info-title" v-if="isEdit">基本信息（只读）</div>

            <div v-if="isEdit" class="form-info-panel" style="padding-left: .4rem;text-align: left;">
                <div class="cus-row cus-row-v-m">
                    <div class="cus-row-col-3">
                        <span class="input-tag">内部发票号</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input">{{ payment_bill_no }}</div>
                    </div>
                </div>

                <div class="barrie-line"></div>

                <div class="cus-row cus-row-v-m" v-if="staff_name">
                    <div class="cus-row-col-3">
                        <span class="input-tag">业务员</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input">{{ staff_name }}{{ staff_mobile ? (' - ' + staff_mobile) : '' }}</div>
                    </div>
                </div>

                <div class="barrie-line" v-if="staff_name"></div>

                <div class="cus-row cus-row-v-m">
                    <div class="cus-row-col-3">
                        <span class="input-tag">内部状态</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input">{{ payment_status_txt }}</div>
                    </div>
                </div>

                <div class="barrie-line" v-if="parseInt(is_urgent) === 1"></div>

                <div class="cus-row cus-row-v-m" v-if="parseInt(is_urgent) === 1">
                    <div class="cus-row-col-3">
                        <span class="input-tag">加急状态</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input" style="display: inline-flex; align-items:center;">
                            <span style="display:inline-flex; align-items:center; background:#fff1f0; color:#cf1322; border-radius: 999px; line-height: 22px; padding: 0 10px; font-size: 12px;">
                                <van-icon name="fire-o" style="margin-right: 4px;" />已加急
                            </span>
                            <span v-if="urgent_applied_at" style="margin-left: 8px; color:#999; font-size:12px;">（{{ urgent_applied_at }}）</span>
                        </div>
                    </div>
                </div>

                <div class="barrie-line" v-if="payment_status == 3"></div>

                <div class="cus-row cus-row-v-m" v-if="payment_status == 3">
                    <div class="cus-row-col-3">
                        <span class="input-tag">不通过原因</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input">{{ payment_audit_remark || '-' }}</div>
                    </div>
                </div>

                <div class="barrie-line" v-if="parseInt(payment_status) === 6"></div>

                <div class="cus-row cus-row-v-m" v-if="parseInt(payment_status) === 6">
                    <div class="cus-row-col-3">
                        <span class="input-tag">失败原因</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input">{{ payment_audit_remark || '-' }}</div>
                    </div>
                </div>

                <div class="barrie-line" v-if="showReceiptRow"></div>

                <div class="cus-row cus-row-v-m" v-if="showReceiptRow">
                    <div class="cus-row-col-3">
                        <span class="input-tag">发票凭证</span>
                    </div>
                    <div class="cus-row-col-9 select-line">
                        <div class="line-input" style="color:#1889f9;" @click="previewReceipt">点击查看</div>
                    </div>
                </div>
            </div>


            <div class="info-title">发票信息</div>

            <div  class="form-info-panel" style="padding-left: .4rem;text-align: left;">


                <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-3">
            <span class="input-tag">关联合同</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <input class="line-input2" :placeholder="contractPlaceholder" readonly @click="openContractPicker" :value="selected_contract_text"/>
          </div>
        </div>


                <div>

                <!-- 合同发票时显示收款信息 -->
                <div v-if="isContractType">
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">公司名称</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入公司名称" v-model="company_name"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">税号</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入税号" v-model="tax_no"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款开户名</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="bank_account_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款开户行</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="bank_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款账号</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="bank_account" type="number"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">公司地址</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入公司地址" v-model="company_address"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">电话</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入电话" v-model="phone"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">邮箱</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入邮箱" v-model="email"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">发票内容</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入发票内容" v-model="invoice_content"/>
                        </div>
                    </div>
                    <div class="barrie-line"></div>
                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">备注</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入备注" v-model="remark"/>
                        </div>
                    </div>
                </div>

                <!-- 报春内转/同行发票时显示供应商信息 -->
                <div v-if="isConfirmType">
                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">名称</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入供应商名称/部门名称" v-model="supplier_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">专线负责人</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="contact_name"/>
                        </div>
                    </div>
                </div>

                <!-- 外币发票时显示专用字段 -->
                <div v-if="isForeignType">
                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">账户所在地区</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_account_region"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">银行详细地址</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_bank_address"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">账户币种</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_account_currency"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">开户银行</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_bank_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">账户名称</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_account_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">账户号码</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_account_number"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">SWIFT银行代码</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_swift_code"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">本地银行代码</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_local_bank_code"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">邮编</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_postal_code"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">公司详细地址</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" v-model="foreign_company_address"/>
                        </div>
                    </div>
                </div>

                </div>

            </div>
            <div class="info-title">发票金额</div>

        <div   class="form-info-panel" style="padding-left: .4rem;text-align: left;">

            <div class="cus-row cus-row-v-m">
                <div class="cus-row-col-3"><span class="input-tag">金额</span></div>
                <div class="cus-row-col-9 select-line">
                    <input class="line-input" placeholder="请输入" v-model="price" type="number"/>
                </div>
            </div>

        </div>

       

        <div class="info-title" v-if="!isEdit && !isConfirmType && !isForeignType">智能识别</div>

        <div class="form-info-panel" style="padding: .4rem;text-align: left;" v-if="!isEdit && !isConfirmType && !isForeignType">
            <div style="background:#ffffff;border-radius: 12px;border:1px solid #efefef;padding: 12px;">
                <textarea
                        v-model="ai_text"
                        placeholder="『粘贴识别』或输入文本，智能拆分姓名、电话和地址"
                        style="width: 100%; min-height: 80px; border: none; outline: none; font-size: .25rem; color:#333;"
                ></textarea>

                <div style="display:flex; align-items:center; justify-content: space-between; margin-top: 12px;">
                    <div style="display:flex; align-items:center;">
                        <div @click="aiUploadImg" style="display:flex; align-items:center; padding: 8px 12px; border-radius: 999px; border:1px solid #efefef; margin-right: 12px;">
                            <img src="../assets/images/add.png" style="width: 18px; height: 18px; margin-right: 6px;"/>
                            <span style="font-size: 14px; color:#222;">图片识别</span>
                        </div>
                        <!-- <div @click="aiVoice" style="display:flex; align-items:center; padding: 8px 12px; border-radius: 999px; border:1px solid #efefef; margin-right: 12px;">
                            <span style="font-size: 14px; color:#222;">语音识别</span>
                        </div> -->
                        <!-- <div @click="aiAddrCode" style="display:flex; align-items:center; padding: 8px 12px; border-radius: 999px; border:1px solid #efefef;">
                            <span style="font-size: 14px; color:#222;">地址码</span>
                        </div> -->
                    </div>
                    <div style="font-size: 0;">
                        <a href="javascript:void(0);" @click="aiRecognize" style="display:inline-flex; align-items:center; padding: 8px 16px; background: linear-gradient(90deg, #ff7a59, #ff3d3d); color:#fff; border-radius: 999px; font-size: 14px;">识别</a>
                    </div>
                </div>
            </div>
        </div>

      


        <div class="in-bl-line" style="padding:0 .5rem;margin-top: .5rem;margin-bottom: 2rem;" v-if="!isEdit">
            <a class="bt" href="javascript:void(0);" v-on:click="nextStep" v-bind:class="{'inEdit':!nextStepValid}">确定</a>
        </div>

        <div style="height: 20px;">

        </div>

        <form style="display: none;" id="data-form">
            <input id="fileTarget" ref="filElem" type="file" name="file"  style="display: none" accept="image/gif,image/jpeg,image/png"  @change="getFile"/>
        </form>

        <form style="display: none;" id="ai-data-form" v-if="!isEdit">
            <input ref="aiFileElem" type="file" name="file"  style="display: none" accept="image/gif,image/jpeg,image/png"  @change="aiGetFile"/>
        </form>

        <CusDatePicker ref="begin_time_select" v-model="pay_date"></CusDatePicker>


        <van-image-preview
                v-model="show"
                :images="images"
                @change="onChange"
        >
        </van-image-preview>

        <!-- 选择关联合同弹层 -->
        <ContractPicker v-model="showContractPicker" @selected="onContractSelected"/>

        <van-overlay :show="isRecognizing" v-if="!isEdit">
            <div style="display: flex;justify-content: center;align-items: center;height: 100%;">
                <van-loading size="24px" vertical>识别中...</van-loading>
            </div>
        </van-overlay>

        <!-- 详情页撤销按钮 -->
        <div class="in-bl-line" style="padding:0 .5rem;margin-top: .5rem;margin-bottom: 16px;" v-if="isEdit && canRevoke">
            <a class="revoke-btn" href="javascript:void(0);" v-on:click="revokePayment">撤销</a>
        </div>

        <!-- 详情页加急按钮 -->
        <div class="in-bl-line" style="padding:0 .5rem;margin-top: .2rem;margin-bottom: 3rem;" v-if="isEdit && canUrgent">
            <a class="urgent-btn" href="javascript:void(0);" v-on:click="applyUrgent">加急审核</a>
        </div>

        <div style="height: 10px;">

        </div>
    
    </div>
    </div>
</template>


<script>
    import common from '../assets/js/common'
    import CusDatePicker from '../modules/cus_date_picker'
    import ContractPicker from '../components/ContractPicker'
    import FileSizeCheck from '../components/FileSizeCheck.vue'
    import store from '../store'
    import axios from 'axios'
    import { Dialog } from 'vant'

    export default {
        name: 'NewTax',
        props: {
            msg: String
        },
        components:
            {
                CusDatePicker,
                ContractPicker,
                FileSizeCheck
            },
        data: function(){
            return {
                price:'',
                currency_code:'CNY',
                payment_type:'1',
                supplier_name:'',
                contact_name:'',
                bank_account_name:'',
                bank_account:'',
                bank_name:'',
                contract_no:'',
                nextLock:'',
                show:false,
                showContractPicker:false,
                images:[],
                selected_contract:null,
                ai_text:'',
                isRecognizing: false,
                payment_bill_no:'',
                payment_status:'',
                payment_audit_remark:'',
                pay_receipt_path:'',
                confirm_proofs:[],
                is_urgent: 0,
                urgent_applied_at: '',
                staff_name: '',
                staff_mobile: '',
                // 新增发票字段
                company_name: '',
                tax_no: '',
                company_address: '',
                phone: '',
                email: '',
                invoice_content: '',
                remark: '',
                // 外币发票专用字段
                foreign_account_region: '',
                foreign_bank_address: '',
                foreign_account_currency: '',
                foreign_bank_name: '',
                foreign_account_name: '',
                foreign_account_number: '',
                foreign_swift_code: '',
                foreign_local_bank_code: '',
                foreign_postal_code: '',
                foreign_company_address: ''
            }
        },
        methods:{
            isPdfUrl(url){
                return /\.pdf$/i.test(url || '')
            },
            isDocxUrl(url){
                return /\.docx$/i.test(url || '')
            },
            getFileNameFromUrl(url){
                try{
                    var parsedUrl = new URL(url)
                    var pathname = parsedUrl.pathname
                    return pathname.substring(pathname.lastIndexOf('/') + 1)
                }catch(e){
                    return url
                }
            },
            deleteConfirmProof(index){
                this.confirm_proofs.splice(index, 1)
            },
            previewConfirmProof(url) {
                // 预览凭证文件图片
                const imageUrl = url.indexOf("http") === 0 ? url : common.dynamicHost() + url;
                this.images = [imageUrl];
                this.show = true;
            },
            getConfirmProofFile(){
                const inputFile = this.$refs.uploadConfirm && this.$refs.uploadConfirm.files[0]
                if(!inputFile){ return }
                var formData = new FormData()
                formData.append('file', inputFile)
                axios.post(common.dynamicHost() + '/upload.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res)=>{
                    this.$refs.uploadConfirm.value = ''
                    res = res.data
                    if(res && res.errcode === 0){
                        this.confirm_proofs.push(common.dynamicHost() + res.path)
                    }else{
                        common.mAlert(this, '上传失败')
                    }
                }).catch(()=>{
                    this.$refs.uploadConfirm.value = ''
                    common.mAlert(this, '上传失败')
                })
            },
            goBack(){
                this.$router.push({ path: '/tax' })
            },
            paymentStatusText(s){
                const map = {1:'待审核',2:'审核通过',3:'审核不通过',4:'已开票', 5:'已撤销', 6:'开票失败'}
                const k = parseInt(s)
                return map[k] || ''
            },
            previewReceipt(){
                if(!this.pay_receipt_path){return}
                const url = this.pay_receipt_path.indexOf('http') === 0 ? this.pay_receipt_path : (common.dynamicHost() + this.pay_receipt_path)
                this.$imagePreview ? this.$imagePreview([url]) : (window.open(url, '_blank'))
            },
            aiUploadImg(){
                if(this.$refs.aiFileElem){
                    this.$refs.aiFileElem.dispatchEvent(new MouseEvent('click'))
                }
            },
            aiGetFile(){
                const inputFile = this.$refs.aiFileElem && this.$refs.aiFileElem.files[0];
                if(!inputFile){
                    return;
                }
                if(inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif'){
                    common.mAlert(this,'不是有效的图片文件');
                    return;
                }

                var formElement = document.querySelector('#ai-data-form');
                var formData = new FormData(formElement);
                // 直接调用ocr.php进行识别
                common.cusHttp(this,'/ocr.php',formData,'post').then((res)=>{
                    this.$refs.aiFileElem.value = '';
                    try {
                        let ocrRes = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                        if(ocrRes.status && ocrRes.data && ocrRes.data.words_result){
                            let lines = [];
                            for(let i=0; i < ocrRes.data.words_result.length; i++){
                                lines.push(ocrRes.data.words_result[i].words);
                            }
                            this.ai_text = lines.join(' ');
                            if (this.ai_text) {
                                this.aiRecognize(); // 识别后自动解析
                            }
                        } else {
                            common.mAlert(this, '图片识别失败');
                        }
                    } catch(e) { common.mAlert(this, '解析识别结果失败'); }
                }).catch(() => {
                    common.mAlert(this, '图片识别请求失败');
                });
            },
            aiPasteRecognize(){
                if(navigator && navigator.clipboard && navigator.clipboard.readText){
                    navigator.clipboard.readText().then(text=>{
                        if(text){
                            this.ai_text = text;
                        }
                    })
                }
            },
            aiVoice(){
                common.mAlert(this,'语音识别暂未开通');
            },
            aiAddrCode(){
                common.mAlert(this,'地址码暂未开通');
            },
            openContractPicker(){
                this.showContractPicker = true;
            },
            onContractSelected(item){
                this.selected_contract = item;
                // 只设置合同信息，不覆盖其他表单数据
            },
            showImage()
            {
                this.show = true;
            },
            nextStep(){

                if( this.nextLock )
                {
                    return;
                }

                // 合同发票和外币发票都必须选择关联合同
                if( (String(this.payment_type) === '1' || String(this.payment_type) === '3') && !this.selected_contract )
                {
                    common.mAlert(this,'请选择关联合同');
                    return;
                }

                //验证
                if (this.isContractType) {
                    // 合同发票验证收款信息
                    if (!this.bank_name) {
                        common.mAlert(this,'收款开户行不能为空');
                        return;
                    }

                    if (!this.bank_account_name) {
                        common.mAlert(this,'收款开户名不能为空');
                        return;
                    }

                    if (!this.bank_account) {
                        common.mAlert(this,'收款账号不能为空');
                        return;
                    }

                    if (!this.email) {
                        common.mAlert(this, '请输入邮箱');
                        return;
                    }

                    if (!this.invoice_content) {
                        common.mAlert(this, '请输入发票内容');
                        return;
                    }
                } else if (this.isConfirmType) {
                    // 报春内转/同行发票验证供应商信息
                    if (!this.supplier_name) {
                        common.mAlert(this,'供应商名称/部门名称不能为空');
                        return;
                    }

                    if (!this.contact_name) {
                        common.mAlert(this,'专线负责人不能为空');
                        return;
                    }
                } else if (this.isForeignType) {
                    // 外币发票验证专用字段
                    if (!this.foreign_account_region) {
                        common.mAlert(this,'账户所在地区不能为空');
                        return;
                    }
                    if (!this.foreign_bank_address) {
                        common.mAlert(this,'银行详细地址不能为空');
                        return;
                    }
                    if (!this.foreign_account_currency) {
                        common.mAlert(this,'账户币种不能为空');
                        return;
                    }
                    if (!this.foreign_bank_name) {
                        common.mAlert(this,'开户银行不能为空');
                        return;
                    }
                    if (!this.foreign_account_name) {
                        common.mAlert(this,'账户名称不能为空');
                        return;
                    }
                    if (!this.foreign_account_number) {
                        common.mAlert(this,'账户号码不能为空');
                        return;
                    }
                    if (!this.foreign_swift_code) {
                        common.mAlert(this,'SWIFT银行代码不能为空');
                        return;
                    }
                    if (!this.foreign_local_bank_code) {
                        common.mAlert(this,'本地银行代码不能为空');
                        return;
                    }
                    if (!this.foreign_postal_code) {
                        common.mAlert(this,'邮编不能为空');
                        return;
                    }
                    if (!this.foreign_company_address) {
                        common.mAlert(this,'公司详细地址不能为空');
                        return;
                    }
                }

                if( !this.price )
                {
                    common.mAlert(this,'金额不能为空');
                    return;
                }

                // 非人民币必须上传外币证明文件
                if(this.currency_code && this.currency_code !== 'CNY'){
                    // 确认件发票必须上传确认件证明
                    if(this.payment_type === '2'){
                        if(!this.confirm_proofs || this.confirm_proofs.length === 0){
                            common.mAlert(this,'请上传确认件证明文件');
                            return;
                        }
                    }
                }

                // if( !this.faceImg )
                // {
                //     common.mAlert(this,'请上传发票资料');
                //     return;
                // }

                // location.href = 'status'
                this.nextLock = true;

                let params = {
                    id: this.id || '',
                    category: 3, // 3=发票
                    type: this.payment_type, // 保持原有逻辑
                    sub_type: this.payment_type, // 1=合同发票, 2=部门间发票, 3=外币发票
                    bank_name:this.bank_name,
                    bank_account_name:this.bank_account_name,
                    bank_account:this.bank_account,
                    price:this.price,
                    currency_code:this.currency_code,
                    confirm_proofs: JSON.stringify(this.confirm_proofs || []),
                    contract_no: this.selected_contract ? (this.selected_contract.contract_numbe || this.selected_contract.bill_no) : (this.contract_no || ''),
                    supplier_name: this.supplier_name,
                    contact_name: this.contact_name,
                    // 新增发票字段
                    company_name: this.company_name,
                    tax_no: this.tax_no,
                    company_address: this.company_address,
                    phone: this.phone,
                    email: this.email,
                    invoice_content: this.invoice_content,
                    remark: this.remark,
                    // 外币发票专用字段
                    foreign_account_region: this.foreign_account_region,
                    foreign_bank_address: this.foreign_bank_address,
                    foreign_account_currency: this.foreign_account_currency,
                    foreign_bank_name: this.foreign_bank_name,
                    foreign_account_name: this.foreign_account_name,
                    foreign_account_number: this.foreign_account_number,
                    foreign_swift_code: this.foreign_swift_code,
                    foreign_local_bank_code: this.foreign_local_bank_code,
                    foreign_postal_code: this.foreign_postal_code,
                    foreign_company_address: this.foreign_company_address,
                };

                common.cusHttp(this,'/admin_user.php?action=add_or_modify_payment',params,'post').then((res)=>{
                    this.nextLock = false;
                    let data;
                    try{
                        data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    }catch(e){
                        const text = res && res.data ? String(res.data).slice(0,200) : '未知错误';
                        common.mAlert(this, '提交失败：' + text);
                        return;
                    }
                    if( data && (data.errcode == 0 || data.status === true) )
                    {
                        this.$router.push('/payment_success?category=3')
                    }else
                    {
                        common.mAlert(this, (data && (data.errmsg || data.message)) || '提交失败');
                    }
                }).catch((err)=>{
                    this.nextLock = false;
                    let msg = '';
                    try{
                        if(err && err.response && err.response.data){
                            msg = typeof err.response.data === 'string' ? err.response.data.slice(0,200) : JSON.stringify(err.response.data).slice(0,200);
                        }
                    }catch(e){ /* no-op */ }
                    common.mAlert(this,'提交失败，请稍后重试' + (msg ? ('：' + msg) : ''));
                });
            },
            closeLayer:function()
            {
                this.layerFlag = false;
            },
            initPage()
            {
                common.cusHttp(this,'/bor/loan_detail',{id:this.id},'get').then((res)=>{
                    if (res.data.errcode == 0)
                    {
                        this.loan_detail = res.data.loan_detail;
                        //取最后一个资方
                        this.capital = res.data.loan_detail.applications.slice(-1)[0];
                    }
                })

                common.cusHttp(this,'/bor/bank_list',{},'get').then((res)=>{
                    if (res.data.errcode == 0)
                    {
                        /*改成自定义系统select支持的数据格式*/
                        let bankArrTmp = [];
                        for( var i = 0 , j = res.data.data.length; i < j; i++ )
                        {
                            bankArrTmp.push({fields:{item_value:res.data.data[i].bank_code,item_name:res.data.data[i].bank_name}});
                        }

                        this.bankArr = bankArrTmp;


                        // this.bankArr  = res.data.data;
                    }
                })
            },
            uploadImg(){
                this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
            },
            getFile()
            {
                // var that = this;
                const inputFile = this.$refs.filElem.files[0];
                if(inputFile){
                    if(inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif'){
                        alert('不是有效的图片文件！');
                        return;
                    }

                    var formElement = document.querySelector("#data-form");
                    var formData = new FormData(formElement);


                    common.cusHttp(this,'/api/api-cloud-img',formData,'post').then((res)=>{
                        this.$refs.filElem.value = '';
                        res = JSON.parse(res.data)
                        if( res.status )
                        {
                            this.faceImg = res.data;
                            // 设置到images数组中用于预览
                            this.images = [common.dynamicHost() + this.faceImg];
                        }
                    }).catch(()=>{
                        common.mAlert(this,'银行卡识别失败');
                    });
                } else {
                    return;
                }
            },
            picSupplier()
            {
                this.$router.push('/suppliers')
            },
            aiRecognize(){
                if( !this.ai_text ){
                    common.mAlert(this,'请输入需要识别的文字');
                    return;
                }

                this.isRecognizing = true;
                common.cusHttp(this, '/aiinvoiceinfo.php', { keyword: this.ai_text }, 'post').then(res => {
                    this.isRecognizing = false;
                    console.log('AI aiiinvoiceinfo.php response:', res.data);
                    try {
                        let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                        if(data.status && data.data && data.data.ai_success){
                            const ai_data = data.data;
                            this.company_name = ai_data.company_name || '';
                            this.tax_no = ai_data.tax_id || '';
                            this.bank_name = ai_data.bank_name || '';
                            this.bank_account_name = ai_data.company_name || '';
                            this.bank_account = ai_data.account_number || '';
                            this.company_address = ai_data.address || '';
                            this.phone = ai_data.phone || '';
                            this.price = ai_data.amount || '';
                            this.email = ai_data.email || '';
                            common.mAlert(this,'识别成功');
                        } else {
                            common.mAlert(this,'识别失败');
                        }
                    } catch(e) { 
                        console.error('Error parsing AI response:', e);
                        common.mAlert(this,'识别失败'); 
                    }
                }).catch((err) => {
                    this.isRecognizing = false;
                    console.error('AI request failed:', err);
                    common.mAlert(this,'识别失败');
                });
            },
            revokePayment(){
                if(!this.id){ return }
                Dialog.confirm({
                    title: '操作提醒',
                    message: '确认要撤销当前发票吗?'
                }).then(()=>{
                    common.cusHttp(this,'/admin_user.php?action=invoice_revoke',{ id: this.id },'post').then((res)=>{
                        try{
                            var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
                            if(data && data.errcode === 0){
                                common.mAlert(this,'撤销成功')
                                this.$router.replace('/tax')
                            }else{
                                common.mAlert(this,(data && data.errmsg) || '撤销失败')
                            }
                        }catch(e){ common.mAlert(this,'撤销失败') }
                    }).catch(()=>{ common.mAlert(this,'撤销失败') })
                }).catch(()=>{})
            },
            applyUrgent(){
                if(!this.id){ return }
                Dialog.confirm({
                    title: '操作提醒',
                    message: '确认要对本单发起加急审核吗?（每日最多3次）'
                }).then(()=>{
                    common.cusHttp(this,'/admin_user.php?action=invoice_urgent',{ id: this.id },'post').then((res)=>{
                        try{
                            var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
                            if(data && data.errcode === 0){
                                common.mAlert(this,'已提交加急')
                                this.is_urgent = 1
                            }else{
                                common.mAlert(this,(data && data.errmsg) || '加急失败')
                            }
                        }catch(e){ common.mAlert(this,'加急失败') }
                    }).catch(()=>{ common.mAlert(this,'加急失败') })
                }).catch(()=>{})
            }
        },
        created:function()
        {
            /**
             * 如果没有token则跳到登录页哟
             */
            common.checkToken(this)

            common.setTitle('确认信息');
            this.id = (this.$route && this.$route.query && this.$route.query.id) ? this.$route.query.id : common.queryValue('id');
        },
        mounted()
        {
            this.$store.commit('setTarbarIndex',1)
            //初始化数据

            // store.commit('setChosenSupplier','')

            // 如果是编辑场景，加载详情并回填（统一使用 admin_user 风格）
            if( this.id ){
                common.cusHttp(this,'/admin_user.php?action=payment_detail',{id:this.id},'get').then((res)=>{
                    try{
                        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
                        const payment = (data.data && data.data.payment) || data.payment || {}
                        const supplier = (data.data && data.data.supplier) || data.supplier || {}
                        const staff = (data.data && data.data.staff) || data.staff || {}

                        // 发票类型（编辑态回填）
                        if(payment.type !== undefined && payment.type !== null){
                            this.payment_type = String(payment.type)
                        }

                        this.bank_name = payment.bank_name || this.bank_name
                        this.bank_account_name = payment.bank_account_name || this.bank_account_name
                        this.bank_account = payment.bank_account || this.bank_account
                        this.price = payment.price || this.price
                        this.currency_code = payment.currency_code || this.currency_code
                        this.contract_no = payment.contract_no || ''
                        this.supplier_name = payment.supplier_name || this.supplier_name
                        this.contact_name = payment.contact_name || this.contact_name

                        // 新增发票字段回填
                        this.company_name = payment.company_name || ''
                        this.tax_no = payment.tax_no || ''
                        this.company_address = payment.company_address || ''
                        this.phone = payment.phone || ''
                        this.email = payment.email || ''
                        this.invoice_content = payment.invoice_content || ''
                        this.remark = payment.remark || ''
                        
                        // 外币发票字段回填
                        this.foreign_account_region = payment.foreign_account_region || ''
                        this.foreign_bank_address = payment.foreign_bank_address || ''
                        this.foreign_account_currency = payment.foreign_account_currency || ''
                        this.foreign_bank_name = payment.foreign_bank_name || ''
                        this.foreign_account_name = payment.foreign_account_name || ''
                        this.foreign_account_number = payment.foreign_account_number || ''
                        this.foreign_swift_code = payment.foreign_swift_code || ''
                        this.foreign_local_bank_code = payment.foreign_local_bank_code || ''
                        this.foreign_postal_code = payment.foreign_postal_code || ''
                        this.foreign_company_address = payment.foreign_company_address || ''

                        // 确认件证明文件
                        if(payment.confirm_proofs){
                            try{
                                this.confirm_proofs = JSON.parse(payment.confirm_proofs) || []
                            }catch(e){ this.confirm_proofs = [] }
                        }

                        // 只读基本信息
                        this.payment_bill_no = payment.bill_no || ''
                        this.payment_status = payment.status || ''
                        this.payment_audit_remark = payment.audit_remark || payment.remark || ''
                        this.pay_receipt_path = payment.pay_receipt_path || ''
                        this.is_urgent = payment.is_urgent || 0
                        this.urgent_applied_at = payment.urgent_applied_at || ''

                        // 业务员信息
                        this.staff_name = staff.name || ''
                        this.staff_mobile = staff.mobile || ''

                        this.supplier_name = supplier.supplier_name || this.supplier_name
                        this.contact_name = supplier.contact_name || this.contact_name
                        this.contact_phone = supplier.contact_phone || this.contact_phone
                        this.address = supplier.address || this.address
                        this.email = supplier.email || this.email

                        if( this.contract_no ){
                            this.selected_contract = { contract_numbe: this.contract_no, bill_no: this.contract_no }
                        }
                    }catch(e){ /* no-op */ }
                }).catch(()=>{ /* keep silent */ })
            }

            // 加载币种列表
            
        },
        computed:{
            isEdit(){
                return !!this.id
            },
            canRevoke(){
                // 待审核(1) 或 审核通过(2) 可撤销，加急订单也可以撤销
                const s = parseInt(this.payment_status)
                return this.isEdit && (s === 1 || s === 2)
            },
            pageTitle(){
                return this.isEdit ? '发票详情' : '新增发票'
            },
            isContractType(){
                return String(this.payment_type) === '1'
            },
            isConfirmType(){
                return String(this.payment_type) === '2'
            },
            isForeignType(){
                return String(this.payment_type) === '3'
            },
            nextStepValid:function () {
                return true;
            },
            payment_status_txt(){
                return this.paymentStatusText(this.payment_status)
            },
            showReceiptRow(){
                return !!this.pay_receipt_path && (parseInt(this.payment_status) === 2 || parseInt(this.payment_status) === 4)
            },
            canUrgent(){
                const s = parseInt(this.payment_status)
                // 待审核(1) 或 审核通过(2) 可加急；已加急或已开票则不再显示
                return this.isEdit && (s === 1 || s === 2) && parseInt(this.is_urgent) !== 1
            },
            selected_contract_text:function(){
                if( this.selected_contract ){
                    return this.selected_contract.contract_numbe || this.selected_contract.bill_no || '';
                }
                return ''
            },
            contractPlaceholder:function(){
                return (this.isContractType || this.isForeignType) ? '请选择（必填）' : '如无合同可不选'
            },
            pickSupplier(){
                return ''
            },
        }
    }
</script>


<style>

    html,body{background-color: #f8f8f8!important;}

    input::-webkit-input-placeholder{
        padding-top: 0;
        line-height: normal ;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .inEdit
    {
        opacity: .4;
    }

    .disableText{color:#999999 !important;}

    .in-bl{display: inline-block;}

    .common-padding{padding: 0 0.625rem;}
    .common-padding2{padding: 0.4rem 0.625rem;}

    .fc-aaaaaa-fs-nor-m{font-family: PingFangSC-Medium;font-size: 0.4375rem;color: #AAAAAA;line-height: .625rem;}

    .camera_text{line-height: 0.4rem;font-family: PingFangSC-Regular;font-size: 0.3rem;font-weight: normal;font-stretch: normal;letter-spacing: 0rem;color: #1889f9;}

    .bank-desc
    {
        font-family: PingFangSC-Regular;
        font-size: 0.438rem;
        color: #111111;
        line-height: 0.625rem;
    }

    .ps-text {
    font-size: 0.22rem;
    line-height: 0.3rem;
    color: #666666;
}

/* 撤销按钮：弱化视觉，避免误触 */
.revoke-btn{
    display: inline-block;
    width: 100%;
    line-height: 0.7rem;
    border-radius: 0.125rem;
    font-size: 0.3rem;
    color: #666666;
    border: 1px solid #d9d9d9;
    background: #ffffff;
}

.urgent-btn{
    display: inline-block;
    width: 100%;
    line-height: 0.7rem;
    border-radius: 0.125rem;
    font-size: 0.3rem;
    color: #ff4d4f;
    border: 1px dashed #ff4d4f;
    background: #fffafa;
}
</style>
